import React, { useEffect, useState, useCallback } from "react";
import CanvasJSReact from "../../../../../../../lib/canvasjs/canvasjs.react";
import Loader from "../../../../../../settings/loader";
import commaNumber from "comma-number";
import "./style.scss";

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJS.addColorSet("barChart4", [
  "#FFA32E",
  "#E38029",
  "#FA8039",
  "#E6693C",
  "#FA684B",
]);

function Slider2(props) {
  const [data, setData] = useState({
    result: null,
    cols: [],
    chart: [],
    chains: [],
  });
  const [load, setLoad] = useState(0);

  // Helper for formatting numbers with suffixes
  const addSymbols = (e) => {
    let suffixes = ["", "K", "M", "B"];
    let order = Math.max(Math.floor(Math.log(e.value) / Math.log(1000)), 0);
    if (order > suffixes.length - 1) order = suffixes.length - 1;
    let suffix = suffixes[order];
    return CanvasJS.formatNumber(e.value / Math.pow(1000, order)) + suffix;
  };

  // Initialize data
  useEffect(() => {
    if (props.data && load === 0) {
      setData((prev) => ({
        ...prev,
        result: props.data,
        cols: props.data.revCent.data.map((data, key) => ({
          name: data.name,
          key: key,
        })),
        chains: props.data.chains.data.map((data, key) => ({
          name: data.name,
          braKey: data.braKey,
          chaKey: data.chaKey,
          key: key,
        })),
      }));
      setLoad(1);
    }
    // eslint-disable-next-line
  }, [props.data, load]);

  // Load chart data
  const loadData = useCallback(() => {
    if (!data.result) return;
    const chartData = data.result.chains.data
      .map((chain) => {
        const revCent = data.cols.map((rev) => ({
          ...rev,
          total: data.result.sales.data
            .filter(
              (sale) =>
                sale.revCent === rev.name && chain.chaKey === sale.chaKey
            )
            .map((sale) => sale.total)
            .reduce((a, b) => a + b, 0),
        }));

        return {
          y: revCent.reduce((a, b) => a + b.total, 0),
          label:
            data.result.brands.data.find(
              (brand) => brand.braKey === chain.braKey
            )?.name +
            " | " +
            chain.name,
          toolTipContent: `{label} : {y} {currency}`,
          currency: chain?.currency?.toUpperCase(),
        };
      })
      .filter((d) => d.y);

    setData((prev) => ({
      ...prev,
      chart: chartData,
    }));
    setLoad(2);
    // eslint-disable-next-line
  }, [data.result, data.cols]);

  useEffect(() => {
    if (load === 1) {
      loadData();
    }
    // eslint-disable-next-line
  }, [load, loadData]);

  // Export logic
  useEffect(() => {
    if (props.export) {
      props.getData({
        type: "image",
        title: "Sales By Revenue Center",
        filter: {
          brands: props.filter.data.brands.map((brand) => brand.name),
          chains: props.filter.data.chains.map((chain) => chain.name),
          revCent: props.filter.data.revCent.map((revCent) => revCent.name),
          payType: props.filter.data.payType.map((payType) => payType.name),
          date: {
            start: props.filter.data.date.start,
            end: props.filter.data.date.end,
          },
        },
        body: {
          table: [
            {
              head: [["Revenue Center", "Total"]],
              body: [
                ...data.chart.map((d) => [
                  d.label,
                  `${d?.currency} ${commaNumber(d.y.toFixed(2))}`,
                ]),
              ],
            },
          ],
          id: "exportPdf_Slide3",
        },
      });
    }
    // eslint-disable-next-line
  }, [props.export, data.chart, props.getData]);

  // Currency logic for axis prefix
  const chainsCurrencies = data?.chart?.map((item) =>
    item?.currency?.toLowerCase()
  );
  const isEqualCurr = chainsCurrencies?.every((val, i, arr) => val === arr[0]);

  const options = {
    colorSet: "barChart4",
    axisX: {
      interval:
        data.result && data.result.chains.data.length > 2 ? 1 : undefined,
      interlacedColor: "#f0f8ff",
    },
    axisY: {
      gridColor: "#d6d6d6",
      gridThickness: 1,
      prefix: isEqualCurr
        ? `${
            chainsCurrencies[0]?.toUpperCase() ||
            props.data.currency.base.toUpperCase()
          }`
        : "",
    },
    toolTip: {
      shared: true,
    },
    data: [
      {
        type: "bar",
        yValueFormatString: `#,##0.00`,
        dataPoints: data.chart,
      },
    ],
  };

  return (
    <div id={"exportPdf_Slide3"}>
      {load < 2 ? <Loader /> : <CanvasJSChart options={options} />}
    </div>
  );
}
export default Slider2;
